module.exports = __webpack_public_path__ + "static/fonts/CatatanPerjalanan.ba4b7d0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/CatatanPerjalanan.eot
// module id = 431
// module chunks = 113